import React from "react"
import styled from "@emotion/styled"

import CheckIcon from "../ui/images/check-icon"
import { useQueryString } from "@capitaria/capitaria-utms"
import { trackEvent } from "../../helpers/tracker"

const WrapperCTA = styled.div`
  padding-top: 56px;
  background: #fafafa;
  color: #000000;
  padding-bottom: 84px;
  width: 100%;
  @media (min-width: 768px) {
    padding-top: 95px;
    padding-bottom: 100px;
  }

  @media (min-width: 1024px) {
    padding-top: 125px;
    padding-bottom: 70px;
  }
`

const TitleCTA = styled.h2`
  font-size: 30px;
  line-height: 118.1%;
  font-weight: bold;
  max-width: 750px;
  padding: 0 40px;
  margin: 0 auto;
  text-align: center;
  @media (max-width: 768px) {
    font-size: 24px;
  }
`

const ContainerCheck = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  padding: 20px 0;

  @media (max-width: 767px) {
    flex-direction: column;
    justify-content: left;
    width: 250px;
    padding: 30px 0;
  }
  > svg {
    margin: 0 6px;
  }
  > span {
    font-weight: 600;
    font-size: 16px;
    line-height: 22px;
  }
`

const Check = styled.div`
  text-align: left;
  margin: 40px 0;
  display: flex;
  align-items: center;
  @media (max-width: 810px) {
    margin: 20px 0;
  }
`

const ContainerButton = styled.div``

const Button = styled.a`
  background: linear-gradient(180deg, #30ab76 0%, #71c552 100%);
  border-radius: 5px;
  border: none;
  box-shadow: 0px 15px 30px rgba(0, 0, 0, 0.15);
  color: #ffffff;
  display: inherit;
  font-size: 14px;
  font-weight: 600;
  height: 48px;
  line-height: 16px;
  margin: 0 auto;
  max-width: 250px;
  padding: 16px;
  text-align: center;
  text-decoration: none;
  & :hover {
    background: linear-gradient(180deg, #30ab76 0%, #46a457 100%);
    transition: 0.3s;
  }
`

const Text = styled.span`
  margin-left: 5px;
`

const CTA = () => {
  const {
    queryString,
    parsedQueryString: { mc_origen: mcOrigen },
  } = useQueryString()

  return (
    <WrapperCTA>
      <TitleCTA>
        Mientras leías esto, un Trader ya encontró una oportunidad. ¿Cuál es tu
        excusa?
      </TitleCTA>
      <ContainerCheck>
        <Check>
          <CheckIcon width="29" height="22" />
          <Text>Regístrate</Text>
        </Check>
        <Check>
          <CheckIcon width="29" height="22" />
          <Text>Deposita</Text>
        </Check>
        <Check>
          <CheckIcon width="29" height="22" />
          <Text>Descarga la plataforma</Text>
        </Check>
        <Check>
          <CheckIcon width="29" height="22" />
          <Text>Opera</Text>
        </Check>
      </ContainerCheck>
      <ContainerButton>
        <Button
          className="gtm-btn-cuenta-3"
          href={`https://onboarding.capitaria.com/sign-up${queryString}`}
          onClick={() => {
            trackEvent("acerca-de-nosotros:cta:create-account", {
              mc_origen: mcOrigen,
            })
          }}
        >
          CREA TU CUENTA
        </Button>
      </ContainerButton>
    </WrapperCTA>
  )
}

export default CTA
